module.exports = __webpack_public_path__ + "fonts/frame_281_1.svg";